import { ThemeProvider } from "@emotion/react";
import { Box, createTheme, FormLabel, Paper, Stack } from "@mui/material";
import { SNormalButton, SText } from "components";
import { STheme } from "components/styles";
import { useContext } from "react";
import { SDialogContext } from "states";

export type MultiDialogEvent = {
  label: string;
  handleSubmit: Function;
};

type Props = {
  title: string;
  msg: string;
  events: MultiDialogEvent[];
};

export const SMultiDialog = (props: Props): JSX.Element => {
  const handleSubmit = useContext(SDialogContext);
  return (
    <ThemeProvider theme={theme}>
      <Paper variant="outlined">
        <Box>
          <Box
            className="handle"
            display="grid"
            sx={{
              backgroundColor: STheme.frames.bar,
              borderColor: STheme.frames.border,
              borderBottomStyle: "solid",
              borderBottomWidth: "1px",
            }}
          >
            <FormLabel>{props.title}</FormLabel>
          </Box>
          <Box padding="2rem" minHeight="2.5rem">
            <SText>{props.msg}</SText>
          </Box>
          <Stack
            marginLeft={6}
            marginRight={6}
            paddingBottom="4rem"
            spacing={2}
            alignItems="stretch"
          >
            {props.events.map((value, index) => (
              <SNormalButton
                key={index}
                label={value.label}
                align="center"
                fullWidth
                sx={{ height: "2.5rem" }}
                onClick={() => {
                  handleSubmit();
                  value.handleSubmit();
                }}
              />
            ))}
          </Stack>
        </Box>
      </Paper>
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            padding: "5px 10px",
            color: STheme.frames.contrastText,
            fontSize: "1rem",
          },
        },
      },
    },
  },
  { ...STheme }
);
